import {Action, GAME_SCRIPT_ORIGIN, IS_ODR_BUILD, ODR_BUILD_ORIGIN} from "@dp-instant/core";
import {injectable} from "inversify";
import {parseLevelSVG} from "@game/coregame/helpers/parseLevelSVG";
import {LevelData} from "@game/coregame/interfaces/LevelData";

@injectable()
export class LoadLevelAction extends Action<string, LevelData> {
    async execute(levelId: string): Promise<any> {
        const fileName = levelId?.endsWith(".svg") ? levelId : levelId + ".svg";
        let req: Response;
        try {
            const origin = IS_ODR_BUILD ? ODR_BUILD_ORIGIN : GAME_SCRIPT_ORIGIN;
            req = await fetch(`${origin}assets/maps/${fileName}`);
        } catch (e: any) {
            throw new Error(e);
        }

        const svgContent = await req.text();
        let doc: Document;
        try {
            doc = new window.DOMParser().parseFromString(svgContent, "text/xml");
        } catch (e) {
            throw new Error(`Failed to parse SVG for level "${levelId}": ${e}`);
        }
        const parseError = doc.querySelector("parsererror");
        if (parseError) {
            throw new Error(`Invalid SVG for level "${levelId}": ${parseError.textContent}`);
        }
        return parseLevelSVG(doc);
    }
}
